import { z } from 'zod';
import { WEBHOOK_EVENT_CODES } from '../types/webhook';

export const webhookEventSchema = z.enum(WEBHOOK_EVENT_CODES);

// HTTPS-only in prod; allow localhost http for dev testing.
const urlSchema = z
  .string()
  .url('URL ไม่ถูกต้อง')
  .max(2048)
  .refine(
    (v) => {
      try {
        const u = new URL(v);
        if (u.protocol === 'https:') return true;
        if (u.protocol === 'http:' && (u.hostname === 'localhost' || u.hostname === '127.0.0.1'))
          return true;
        return false;
      } catch {
        return false;
      }
    },
    { message: 'URL ต้องเป็น https:// (หรือ http://localhost สำหรับทดสอบ)' },
  );

export const createWebhookSchema = z.object({
  url: urlSchema,
  events: z.array(webhookEventSchema).min(1, 'เลือก event อย่างน้อย 1 ตัว'),
  description: z.string().max(500).optional().nullable(),
});

export const updateWebhookSchema = z.object({
  url: urlSchema.optional(),
  events: z.array(webhookEventSchema).min(1).optional(),
  isActive: z.boolean().optional(),
  description: z.string().max(500).optional().nullable(),
});

export type CreateWebhookInput = z.infer<typeof createWebhookSchema>;
export type UpdateWebhookInput = z.infer<typeof updateWebhookSchema>;
